// 调用前设置好字体样式
export const drawTextWithLetterSpacing = (
    ctx: CanvasRenderingContext2D,
    text: string,
    letterSpacing: number,
    middle: number,
    top: number
) => {
    const length = text.length
    const textWidth: number[] = []
    let sum = 0
    for (let i = 0; i < length; i++) {
        const { width } = ctx.measureText(text[i])
        sum += width
        textWidth.push(sum)
    }
    const totalWidth = textWidth[length - 1] + letterSpacing * (length - 1)
    const start = middle - totalWidth / 2
    for (let i = 0; i < length; i++) {
        ctx.fillText(
            text[i],
            i === 0 ? start : start + textWidth[i - 1] + letterSpacing * i,
            top
        )
    }
}

export const drawTextWithMultiLine = (
    context: CanvasRenderingContext2D,
    text: string,
    x: number,
    y: number,
    maxWidth: number,
    lineHeight: number
) => {
    const canvas = context.canvas

    if (typeof maxWidth == "undefined") {
        maxWidth = (canvas && canvas.width) || 300
    }
    if (typeof lineHeight == "undefined") {
        lineHeight =
            (canvas && parseInt(window.getComputedStyle(canvas).lineHeight)) ||
            parseInt(window.getComputedStyle(document.body).lineHeight)
    }

    // 字符分隔为数组
    const arrText = text.split("")
    let line = ""

    for (let n = 0; n < arrText.length; n++) {
        const testLine = line + arrText[n]
        const metrics = context.measureText(testLine)
        const testWidth = metrics.width
        if (testWidth > maxWidth && n > 0) {
            context.fillText(line, x, y)
            line = arrText[n]
            y += lineHeight
        } else {
            line = testLine
        }
    }
    context.fillText(line, x, y)
}
